import React from "react";
export default function GenerationsOfFlavor() {
  return <section data-section-id="244352" id="the-hywm-ethos" className="relative py-20 md:py-32 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.08] bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/diagonal_line_pattern.png')] bg-repeat pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          {}
          <div className="order-2 lg:order-1 relative mx-auto w-full max-w-md lg:max-w-none">
            {}
            <div className="bg-card p-4 md:p-6 shadow-xl rounded-2xl transition-transform hover:scale-[1.02] duration-700 ease-out">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/hard_working_team_action.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/hard_working_team_action.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/hard_working_team_action.png-wvc-sizes" alt="The Hard Working Young Men team on a project site" className="w-full h-auto aspect-[3/4] object-cover rounded-lg contrast-110" loading="lazy" />
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 flex flex-col gap-8">
            <div className="space-y-6">
              <span className="inline-block px-4 py-1.5 bg-secondary text-secondary-foreground text-xs font-bold uppercase tracking-widest rounded-md">
                Our Philosophy
              </span>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-primary tracking-tighter uppercase">
                The HYWM Ethos
              </h2>
              <div className="w-16 h-1 bg-secondary rounded-lg" />
            </div>

            <div className="space-y-6 text-lg md:text-xl text-muted-foreground font-default leading-relaxed">
              <p>
                Hard Working Young Men isn't just a name—it's a standard of
                excellence we bring to every property. We believe that elite
                landscaping requires more than just tools; it demands a relentless
                work ethic and an eye for architectural precision.
              </p>
              <p>
                From precision mowing to complex hardscape installations, our
                team approaches every blade of grass and every stone with the
                same dedication to quality. We work hard so you can enjoy more,
                transforming your outdoor space into a ruggedly luxurious
                sanctuary that stands the test of time.
              </p>
            </div>

            {}
            <div className="mt-8 pt-8 border-t border-border/60 relative">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-4xl md:text-5xl font-serif text-primary tracking-wide">
                    Tyler & Sean
                  </p>
                  <p className="text-sm text-muted-foreground font-default mt-3 uppercase tracking-widest font-semibold">
                    Founders & Project Leads
                  </p>
                </div>
                <div className="hidden md:block opacity-80">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/certified_elite_gold_seal.png" alt="Certified Elite Seal" className="w-24 h-24 object-contain" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}